import React from 'react';
import PropTypes from 'prop-types';
import {
  EmailShareButton,
  FacebookShareButton,
  LinkedinShareButton,
  TelegramShareButton,
  TwitterShareButton,
  RedditShareButton,
  WhatsappShareButton,
  EmailIcon,
  FacebookIcon,
  LinkedinIcon,
  RedditIcon,
  WhatsappIcon,
  TelegramIcon,
  TwitterIcon,
} from 'react-share';
import './ShareButton.scss';
import Image from '../Icons/Image';
import FacebookPng from '../../../images/facebook.png';
import Icon from '../Icon/Icon';

const iconSize = 45;

const ShareIcon = ({ name, color, style, children }) => (
  <div className="share-button-wrapper" style={{ backgroundColor: color }}>
    {children || <Icon name={name} style={style} />}
  </div>
);

const ShareButton = ({ shareChannel, name, url, ...rest }) =>
  shareChannel === 'Twitter' ? (
    <TwitterShareButton url={url}>
      <TwitterIcon size={iconSize} round />
    </TwitterShareButton>
  ) : shareChannel === 'Facebook' ? (
    <FacebookShareButton url={url}>
      <ShareIcon name="facebook" color="#1773EA">
        <img src={FacebookPng} alt="facebook" style={{ width: '15px' }} />
      </ShareIcon>
    </FacebookShareButton>
  ) : shareChannel === 'Email' ? (
    <EmailShareButton url={url}>
      <ShareIcon color="#7F7F7F">
        <Icon name="mail" />
      </ShareIcon>
    </EmailShareButton>
  ) : shareChannel === 'Telegram' ? (
    <TelegramShareButton url={url}>
      <ShareIcon name="telegram" color="#24AAEC" />
    </TelegramShareButton>
  ) : shareChannel === 'Reddit' ? (
    <RedditShareButton url={url}>
      <RedditIcon size={iconSize} round />
    </RedditShareButton>
  ) : shareChannel === 'Linkedin' ? (
    <LinkedinShareButton url={url}>
      <LinkedinIcon size={iconSize} round />
    </LinkedinShareButton>
  ) : (
    <WhatsappShareButton url={url}>
      <WhatsappIcon size={iconSize} round />
    </WhatsappShareButton>
  );

ShareIcon.defaultProps = {
  style: {},
  children: null,
  name: '',
};

ShareButton.propTypes = {
  shareChannel: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired,
};

ShareIcon.propTypes = {
  name: PropTypes.string,
  color: PropTypes.string.isRequired,
  style: PropTypes.object,
  children: PropTypes.node,
};

export default ShareButton;
